import axios from 'axios';
import cookie from '../cookieHelper/cookie'; // Assuming you have a cookie helper

export default function addCover(data) {
    // Retrieve the authentication token from cookies
    const authToken = cookie.getCookie(process.env.REACT_APP_COOKIE_NAME);


    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${authToken}`,
        },
    };

    const API_URL = process.env.REACT_APP_BASE_URL + '/api/v1/story/cover';
    return (
        axios.post(API_URL, data, config)
        .then(res => {
            // console.log("res: ", res);
            return res.data;
        })
        .catch(err => {
            // console.log("err: ", err);
            return err;
        })
    );
}
